export const roundDecimal = (number) => {
  const rounded = Math.round((number + Number.EPSILON) * 100) / 100;
  return rounded || 0;
};

export const floorDecimal = (number) => {
  const rounded = Math.floor((number + Number.EPSILON) * 100) / 100;
  return rounded || 0;
};
